import React, { useCallback } from 'react';
import { UserAccountLink } from './UserAccountMenu';
import css from './UserAccountMenu.module.scss';
import { Link } from '@framework-controls/core';
import { CustMode } from 'src/enums';
import classNames from 'classnames';

export interface IProps {
    id: string;
    header: string;
    theme: string;
    links: UserAccountLink[];
    clickHandler: (componentId: string, label: string, custModeType: CustMode, linkId: string) => void;
}

const UserAccountPanel = (props: IProps) => {
    const displayLinks: React.ReactElement[] = [];

    let linkClassName = css.linkButton;
    if (props.theme === 'colorSensitive') {
        linkClassName = css.linkButtonADA;
    } else if (props.theme === 'lexus') {
        linkClassName = classNames (
            css.linkButton, css.linkButtonADA,
        );
    } else if (props.theme === 'buick') {
        linkClassName = classNames(
            css.linkButton, css.linkButtonBuick,
        );
    } else if (props.theme === 'bmw') {
        linkClassName = classNames(
            css.linkButton, css.linkButtonBMW,
        );
    } else if (props.theme === 'mazda') {
        linkClassName = classNames(
            css.linkButton, css.linkButtonMazda,
        );
    } else if (props.theme === 'genesis'){
        linkClassName = classNames(
            css.linkButton, css.linkButtonGenesis,
        );
    }

    const headerClassNames = classNames(
        css.header,
        {
            [css.headerHonda]: props.theme === 'honda',
            [css.headerBuick]: props.theme === 'buick',
            [css.headerBMW]: props.theme === 'bmw',
            [css.headerFord]: props.theme === 'ford',
            [css.headerIN]: props.theme === 'infiniti',
            [css.headerMazda]: props.theme === 'mazda',
            [css.headerAcura]: props.theme === 'acura',
            [css.headerGenesis]: props.theme === 'genesis',
        },
    );

    const clickHandler = useCallback((componentId: string, label: string, custModeType: CustMode, linkId: string) => {
        props.clickHandler(componentId, label, custModeType, linkId);
    }, [props.clickHandler]);

    // if the user pressed Enter (32) or spacebar (13) when focus is on a link
    // then we want to act as if they had done a mouse click on the link.
    const keyFunction = useCallback((e, componentId: string, label: string, custModeType: CustMode, linkId: string) => {
        if (e.keyCode === 32 || e.keyCode === 13) {
            props.clickHandler(componentId, label, custModeType, linkId);
        }
    }, [props.clickHandler]);

    // for each item in the link array build the link to the screen.
    props.links.forEach((link, index) => {
        if (!link.hide) {
            const isBMWDisabled = props.theme === 'bmw' && link.disabled;
            const displaylink: React.ReactElement = (
                <span className={css.linkSpan} key={index}>
                    <span className={css.linkLink} id={'Span' + link.id} key={index} tabIndex={0} onKeyDown={(e) => keyFunction(
                        e, link.componentId, link.label, link.custModeType, link.id)}>
                        <Link className={classNames(linkClassName, { [css.disabled]: isBMWDisabled })}
                            key={link.id} id={link.id}
                            onClick={() => clickHandler(link.componentId, link.label, link.custModeType, link.id)}
                            disabled={link.disabled}>{link.label}</Link>
                    </span>
                    <span className={css.linkSpace}>
                    </span>
                </span>
            );
            displayLinks.push(displaylink);
        }
    });

    return (
        <div className={css.linkRow}>
            {props.theme !== 'buick' && <hr className={css.headerHR} />}
            <h3 className={headerClassNames}>{props.header}</h3>
            {props.theme !== 'buick' && <hr className={css.headerHRB} />}
            {displayLinks}
        </div>
    );
};

export default UserAccountPanel;